import React from 'react';
import clsx from 'clsx';

export const PlayIndicatorBars = ({
  size = 'sm',
  smallBars,
}: {
  size?: 'xs' | 'sm';
  smallBars?: boolean;
}) => {
  const sharedBarStyles = `flex-shrink-0 block w-[3px] bg-fuchsia500  origin-center transition-all duration-100 ease-in-out rounded-full
  ${smallBars ? 'h-3' : 'h-4'}`;
  return (
    <div
      className={clsx(
        'flex flex-shrink-0 items-center justify-between',
        size === 'xs' && 'h-3.5 w-3',
        size === 'sm' && 'h-4 w-[13.5px]',
      )}
    >
      <div
        className={clsx(
          sharedBarStyles,
          smallBars
            ? ' animate-[playPulse_0.5s_ease-in-out_-0.2s_infinite_alternate] '
            : ' animate-[playPulse_0.45s_ease-in-out_-0.2s_infinite_alternate] ',
        )}
      />
      <div
        className={clsx(
          sharedBarStyles,
          smallBars
            ? 'animate-[playPulse_0.65s_ease-in-out_-0.7s_infinite_alternate] '
            : 'animate-[playPulse_0.6s_ease-in-out_-0.6s_infinite_alternate] ',
        )}
      />
      <div
        className={clsx(
          sharedBarStyles,
          smallBars
            ? 'animate-[playPulse_0.35s_ease-in-out_-0.5s_infinite_alternate] '
            : 'animate-[playPulse_0.3s_ease-in-out_-0.4s_infinite_alternate] ',
        )}
      />
    </div>
  );
};

export const PlayContentWrapper = ({ children }: { children: React.ReactNode }) => (
  <div className="flex max-w-full items-center gap-1">{children}</div>
);
